import {InfoPage, RsnButton} from '@raison/ui-kit';
import React, {useEffect} from 'react';

export type PasswordIsSetProps = {
    onButtonClick: () => void;
    onUnmount?: () => void;
    buttonText?: string;
};

export function PasswordIsSet({onButtonClick, onUnmount}: PasswordIsSetProps) {
    useEffect(() => onUnmount, []);
    return (
        <div className='flex h-full flex-1 flex-col'>
            <InfoPage.Layout symbol={'success'}>
                {{
                    center: (
                        <InfoPage.Center
                            heading={'Password is set'}
                            details={
                                'Make sure to remember it, as in case of loss, account recovery will take some time.'
                            }
                        />
                    ),
                    footer: (
                        <InfoPage.Footer>
                            <RsnButton.Primary type='submit' onClick={onButtonClick}>
                                Continue
                            </RsnButton.Primary>
                        </InfoPage.Footer>
                    ),
                }}
            </InfoPage.Layout>
        </div>
    );
}
